import type React from 'react';

type Props = {
  children: React.ReactNode;
};

const InquiriesContainer = ({ children }: Props) => <>{children}</>;

export default InquiriesContainer;
